/*
 * @Author: zhaosujuan zhaosujuan@freedodata.com
 * @Date: 2022-10-31 16:52:05
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-11-14 17:37:44
 * @FilePath: \lyws-official-websit\src\components\aboutUs\data.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// import 
export const pdList = [
    {url:require('../../../static/images/qualificationDoc/zs1.png')},
    {url:require('../../../static/images/qualificationDoc/zs2.png')},
    {url:require('../../../static/images/qualificationDoc/zs3.png')},
    {url:require('../../../static/images/qualificationDoc/zs4.png')},
    {url:require('../../../static/images/qualificationDoc/zs5.png')},
]
export const pdListB = [
    [
        {url:require('../../../static/images/qualificationDoc/qd1.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd2.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd3.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd4.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd5.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd6.jpg')}, 
    ],
    [
        {url:require('../../../static/images/qualificationDoc/qd7.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd8.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd9.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd10.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd11.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd12.jpg')}, 
    ],
    [
        {url:require('../../../static/images/qualificationDoc/qd13.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd14.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd15.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd16.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd17.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd18.jpg')},
    ],
    [
        {url:require('../../../static/images/qualificationDoc/qd19.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd20.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd21.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd22.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd23.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd24.jpg')},
    ],
    [
        {url:require('../../../static/images/qualificationDoc/qd25.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd26.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd27.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd28.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd29.jpg')},
        {url:require('../../../static/images/qualificationDoc/qd30.jpg')}, 
    ],
]

export const teamList = [
    {
        title:'张建斌',
        subTitle:'创始人、董事长',
        desc:[
            '创始人、董事长及首席执行官。全面负责本集团策略、公司文化及关键产品，并监督高级管理团队。',
            '高级工商管理硕士。曾担任国际知名500强公司中国区业务负责人。建立了与多家知名国内外企业的战略合作。',
            '08年开始创业，相继创立了才聚服务、云聚科技、云攀科技、飞渡数字等多家企业。',
        ]
    },
]


// WEBPACK FOOTER //
// ./src/components/aboutUs/data.js